const Url = "https://api.bizzmate.co.in/"

export const URLS = {
  Base: Url,

  /////////////////////////Manage-Dashboard-start///////////////////////////
  //Manage-Dashboard
  GetDashboard:
    Url + "v1/bizzmateApi/vendor/dashboardscreen/getallmysupplierstores",

  /////////////////////////Manage-Dashboard-End///////////////////////////

  /////////////////////////Manage-Customers-start///////////////////////////

  GetCustomers: Url + "v1/bizzmateApi/vendor/getsuppliercustomers",
  UpdateCustomerpayments: Url + "v1/bizzmateApi/web/auth/updatepayments",
  GetOneCustomers: Url + "v1/bizzmateApi/vendor/getsuppliercustomerorders",

  /////////////////////////Manage-Customers-End///////////////////////////

  /////////////////////////Manage-Orders-start///////////////////////////

  GetAllOrders: Url + "v1/bizzmateApi/vendor/supplier/getordersbystoreid",
  UpdateOrderUpdate: Url + "v1/bizzmateApi/vendor/supplier/updateorderstatus/",
  GetOneOrders: Url + "v1/bizzmateApi/vendor/order/getorderdetailsbyorderid",

  //Update Order Status
  OrderAccept: Url + "v1/bizzmateApi/vendor/order/accept",
  OrderReject: Url + "v1/bizzmateApi/vendor/order/reject ",
  OrderShipped: Url + "v1/bizzmateApi/vendor/order/shiped",
  OrderCompleted: Url + "v1/bizzmateApi/vendor/order/complete",
  OrderPaymentConfirmation:
    Url + "v1/bizzmateApi/vendor/order/updateConfirmation",

  /////////////////////////Manage-Orders-End///////////////////////////

  /////////////////////////Manage-Notification-start///////////////////////////

  GetNotification:
    Url + "v1/bizzmateApi/vendor/notification/getallnotificationsbyuserid",

  GetNotifications:
    Url + "v1/bizzmateApi/vendor/notification/getallnotificationsbyuserid",

  /////////////////////////Manage-Notification-End///////////////////////////

  /////////////////////////Manage-profile-start////////////////////////////////

  //Personal-Details
  Register: Url + "v1/bizzmateApi/vendor/auth/register",
  getProfile: Url + "v1/bizzmateApi/vendor/auth/getvendorprofile",
  UpdateProfile: Url + "v1/bizzmateApi/vendor/auth/editvendorprofile",
  UpdatePhone: Url + "v1/bizzmateApi/vendor/auth/sendotpforupdatemobilenumber",
  UpdateOtp: Url + "v1/bizzmateApi/vendor/auth/updatemobilenumberwithotp",
  ChangePass: Url + "v1/bizzmateApi/vendor/auth/changecurrentpassword",
  ChangePin: Url + "v1/bizzmateApi/vendor/auth/changesecuritypin",
  forget: Url + "v1/bizzmateApi/vendor/auth/generateotp",
  OTP: Url + "v1/bizzmateApi/vendor/auth/validotp",
  Resetpass: Url + "v1/bizzmateApi/vendor/auth/setpassword",

  //GetAddress
  AddAddress: Url + "v1/bizzmateApi/vendor/useradress/adduseraddress",
  GetAddress: Url + "v1/bizzmateApi/vendor/useradress/getalluseraddress",
  EditAddress: Url + "v1/bizzmateApi/vendor/useradress/edituseraddress/",
  DeleteAddress: Url + "v1/bizzmateApi/vendor/useradress/deleteuseraddress/",

  //GetPayments
  AddPaymentAccount:
    Url + "v1/bizzmateApi/vendor/paymentaccount/addpaymentaccount",
  GetPaymentAccount:
    Url + "v1/bizzmateApi/vendor/paymentaccount/getallpaymentaccounts",
  EditPaymentAccount:
    Url + "v1/bizzmateApi/vendor/paymentaccount/editpaymentaccount/",
  DeletePaymentAccount:
    Url + "v1/bizzmateApi/vendor/paymentaccount/deletepaymentaccount/",

  /////////////////////////Manage-profile-End////////////////////////////////

  /////////////////////////Manage-Supplier-Start////////////////////////////////

  //Stores
  AddStore: Url + "v1/bizzmateApi/vendor/store/addstore",
  GetStore: Url + "v1/bizzmateApi/vendor/store/getallstores",
  GetOneStore: Url + "v1/bizzmateApi/vendor/store/getstorebyid",
  GetStoreSearch: Url + "v1/bizzmateApi/vendor/store/getallstores?searchQuery=",
  EditStore: Url + "v1/bizzmateApi/vendor/store/updatestore/",
  GetAllDeliveryTypes:
    Url + "v1/bizzmateApi/vendor/getdocs/getalldeliverytypes",
  DeleteStore: Url + "v1/bizzmateApi/vendor/store/deletestore/",

  //Product
  AddProduct: Url + "v1/bizzmateApi/vendor/product/addproduct",
  GetProduct: Url + "v1/bizzmateApi/vendor/product/getallproducts",
  GetProductSearch:
    Url + "v1/bizzmateApi/vendor/product/getallproducts?searchQuery=",
  GetOneProduct: Url + "v1/bizzmateApi/vendor/product/getproductbyid",
  DeleteProduct: Url + "v1/bizzmateApi/vendor/product/deleteproduct/",
  GetAdminProducts: Url + "v1/bizzmateApi/vendor/get-admin-products",
  AddAdminProducts: Url + "v1/bizzmateApi/vendor/add-admin-product",
  // GetCategory: Url + "v1/bizzmateApi/vendor/category/getallcategorys",

  //Tax Category
  GetTaxCategory: Url + "v1/bizzmateApi/vendor/getalltaxcategories",
  GetTaxSubCategory: Url + "v1/bizzmateApi/vendor/getsubcat-by-taxcatid",

  GetCategory: Url + "v1/bizzmateApi/vendor/getdocs/getallcategorys",
  GetSubCategory:
    Url +
    "v1/bizzmateApi/vendor/getdocs/getallsubcategoriesundersinglecategory",
  GetChildCategories:
    Url + "v1/bizzmateApi/vendor/getdocs/getallchildcategoriesundersubcategory",

  //GetCountrys
  GetCountry: Url + "v1/bizzmateApi/vendor/getdocs/getallcountrys",
  GetCountrybyStateId:
    Url + "v1/bizzmateApi/vendor/getdocs/getstatebycountryid",
  GetStatebyCityId: Url + "v1/bizzmateApi/vendor/getdocs/getcitiesbystateid",
  GetStatebyDistrictId:
    Url + "v1/bizzmateApi/vendor/getdocs/get-districtsby-stateid",
  GetDistrictIdbyPincode:
    Url + "v1/bizzmateApi/vendor/getdocs/get-pincodes-by-districtid",

  GetMultiCountrybyStateId:
    Url + "v1/bizzmateApi/vendor/getdocs/getstatesbycountryids",
  GetMultiStatebyDistrictId:
    Url + "v1/bizzmateApi/vendor/getdocs/getalldistrict",
  GetMultiDistrictIdbyPincode:
    Url + "v1/bizzmateApi/vendor/getdocs/getallPincodes",

  //BizzCategories
  GetBizzCategory: Url + "v1/bizzmateApi/vendor/getdocs/getallbizcategorys",

  //Deal Priority Locations
  DealPriorityLocations: Url + "v1/bizzmateApi/vendor/deal/getCounteries-data",
  AdvPriorityLocations:
    Url + "v1/bizzmateApi/vendor/advertisement/getCounteries-data",

  //Seller
  AddSeller: Url + "v1/bizzmateApi/admin/store/addstore",
  GetSeller: Url + "v1/bizzmateApi/admin/store/getallsotres",
  GetOneSeller: Url + "v1/bizzmateApi/admin/store/getSellerAndStoreById",
  GetSellerSearch: Url + "v1/bizzmateApi/admin/store/getallsotres?searchQuery=",
  EditSeller: Url + "v1/bizzmateApi/admin/store/editstore/",
  DeleteSeller: Url + "v1/bizzmateApi/admin/tesimonial/deletetestimonial/",

  //Salesman
  AddSalesman: Url + "v1/bizzmateApi/vendor/salesman/addsalesman",
  GetSalesman: Url + "v1/bizzmateApi/vendor/salesman/getallsalesmans",
  GetSalesmanSearch: Url + "v1/bizzmateApi/vendor/salesman/getallsalesmans?searchQuery=",
  EditSalesman: Url + "v1/bizzmateApi/vendor/salesman/editsalesman",
  DeleteSalesman: Url + "v1/bizzmateApi/vendor/salesman/deletesalesman/",
  UpdateSalesmanStatus: Url + "v1/bizzmateApi/vendor/salesman/update-status-salesman",


  //RECEIPT ACCOUNTS
  AddRecepitAccount:
    Url + "v1/bizzmateApi/vendor/receiptaccount/addreceiptaccount",
  GetRecepitAccount:
    Url + "v1/bizzmateApi/vendor/receiptaccount/getallreceiptaccounts",
  EditRecepitAccount:
    Url + "v1/bizzmateApi/vendor/receiptaccount/editreceiptaccount/",
  DeleteRecepitAccount:
    Url + "v1/bizzmateApi/vendor/receiptaccount/deletereceiptaccount/",

  /////////////////////////Manage-Supplier-End////////////////////////////////

  /////////////////////////Manage-Promotions-Start/////////////////////////////

  //Deals
  AddDeal: Url + "v1/bizzmateApi/vendor/deal/adddeal",
  GetDeal: Url + "v1/bizzmateApi/vendor/deal/getalldeals",
  GetDealSearch: Url + "v1/bizzmateApi/vendor/deal/getalldeals?searchQuery=",
  EditDeal: Url + "v1/bizzmateApi/vendor/deal/editdeal/",
  DeleteDeal: Url + "v1/bizzmateApi/vendor/deal/deletedeal/",
  GetOneDeal: Url + "v1/bizzmateApi/vendor/deal/getdealbyid",
  GetDealCategory: Url + "v1/bizzmateApi/vendor/getdocs/getalldealcategorys",
  GetDealByPriority:
    Url + "v1/bizzmateApi/vendor/deal/getmanagedealpricesbydealcategoryid",

  //DealsProducts
  AddDealProduct: Url + "v1/bizzmateApi/vendor/dealproduct/adddealproduct",
  GetDealProduct: Url + "v1/bizzmateApi/vendor/dealproduct/getalldealproducts",
  GetDealSearchProduct:
    Url + "v1/bizzmateApi/vendor/dealproduct/getalldealproducts?searchQuery=",
  EditDealProduct: Url + "v1/bizzmateApi/vendor/dealproduct/updateproduct/",
  DeleteDealProduct: Url + "v1/bizzmateApi/vendor/dealproduct/deleteproduct/",
  AddDealPayment: Url + "v1/bizzmateApi/vendor/dealpayment/adddealpayment",

  //Deals-Advertisement-Common
  GetDealCities:
    Url + "v1/bizzmateApi/vendor/getdocs/getalldeliverycitiesbystore",
  GetDealCustomers:
    Url + "v1/bizzmateApi/vendor/getdocs/getallcustomersbystore",

  //Advertisement
  AddAdvertisement:
    Url + "v1/bizzmateApi/vendor/advertisement/addadvertisement",
  GetAdvertisement:
    Url + "v1/bizzmateApi/vendor/advertisement/getalladvertisements",
  GetAdvertisementSearch:
    Url +
    "v1/bizzmateApi/vendor/advertisement/getalladvertisements?searchQuery=",
  EditAdvertisement:
    Url + "v1/bizzmateApi/vendor/advertisement/editadvertisement/",
  DeleteAdvertisement:
    Url + "v1/bizzmateApi/vendor/advertisement/deleteadvertisement/",
  GetOneAdvertisement:
    Url + "v1/bizzmateApi/vendor/advertisement/getadvertisementbyid",
  GetAdvertisementCategory:
    Url + "v1/bizzmateApi/vendor/getdocs/getalladvcategorys",
  GetAdvertisementByPriority:
    Url + "v1/bizzmateApi/vendor/advertisement/getadvpricesbyadvcategory",
  AddAdvertisementPayment:
    Url + "v1/bizzmateApi/vendor/advpayment/addadvpayment",
  GetAllAdvertisementPayment:
    Url + "v1/bizzmateApi/vendor/advpayment/getalladvpayments",

  //Manage VARIATIONS
  AddManageVariation:
    Url + "v1/bizzmateApi/vendor/productvariation/addproductvariation",
  GetManageVariation:
    Url + "v1/bizzmateApi/vendor/productvariation/getallproductvariations",
  GetManageVariationSearch:
    Url +
    "v1/bizzmateApi/vendor/productvariation/getallproductvariations?searchQuery=",
  EditManageVariation:
    Url + "v1/bizzmateApi/vendor/productvariation/updatteproductvariation/",
  DeleteManageVariation:
    Url + "v1/bizzmateApi/vendor/productvariation/deleteproductvariation/",

  //VARIATIONS
  AddVariation: Url + "v1/bizzmateApi/vendor/variation/addvariation",
  GetVariation: Url + "v1/bizzmateApi/vendor/variation/getallvariations",
  GetVariationSearch:
    Url + "v1/bizzmateApi/vendor/variation/getallvariations?searchQuery=",
  EditVariation: Url + "v1/bizzmateApi/vendor/variation/editvariation/",
  DeleteVariation: Url + "v1/bizzmateApi/vendor/variation/deletevariation/",

  GetVariationByOptions:
    Url + "v1/bizzmateApi/vendor/getdocs/getvariationoptionsbyvariantId",

  //VARIATION OPTIONS
  AddVariationOptions:
    Url + "v1/bizzmateApi/vendor/variationoption/addvariationoption",
  GetVariationOptions:
    Url + "v1/bizzmateApi/vendor/variationoption/getallvariationoptions",
  GetVariationOptionsSearch:
    Url +
    "v1/bizzmateApi/vendor/variationoption/getallvariationoptions?searchQuery=",
  EditVariationOptions:
    Url + "v1/bizzmateApi/vendor/variationoption/editvariationoption/",
  DeleteVariationOptions:
    Url + "v1/bizzmateApi/vendor/variationoption/deletevariationoption/",

  /////////////////////////Manage-Promotions-End///////////////////////////////

  /////////////////////////Manage-Help////////////////////////////////
  //Help
  AddHelp: Url + "v1/bizzmateApi/vendor/support/addusersupport",
  GetHelp: Url + "v1/bizzmateApi/vendor/support/getallusersupport",
  GetHelpSearch:
    Url + "v1/bizzmateApi/vendor/support/getallusersupport?searchQuery=",
  DeleteHelp: Url + "v1/bizzmateApi/vendor/support/deleteusersupport/",

  //Admin apis
  GetAbout: Url + "v1/bizzmateApi/admin/aboutus/getaboutus",
  GetFaq: Url + "v1/bizzmateApi/admin/faq/getallfaqs",
  GetContact: Url + "v1/bizzmateApi/admin/contactus/getcontactus",
  GetPolicy: Url + "v1/bizzmateApi/admin/policy/get",

  //Subscriptions
  GetSubscription: Url + "v1/bizzmateApi/vendor/getdocs/getallsubscriptions",
  BuySubscription: Url + "v1/bizzmateApi/vendor/subscribe/addpurchaseplan",
  GetCurrentSubscription: Url + "v1/bizzmateApi/vendor/subscribe/getallmyplans",
  GetOneCurrentSubscription:
    Url + "v1/bizzmateApi/vendor/subscribe/getmysubscribebyid",
  GetSubscriptionPopUp: Url + "v1/bizzmateApi/vendor/subscribe/getpopup",
  CancelSubscription: Url + "v1/bizzmateApi/vendor/cancel-subscription/",

  DeleteNotification:
    Url + "v1/bizzmateApi/vendor/notification/deletenotification",
}
